import React from "react";
import Payment from "./Payment";
import { Shoptopbar } from "Components/ShopTopBar";


const PaymentIndex = () => {
    document.title = "Shop  | Toner - React FrontEnd";

    return (
        <React.Fragment>
            <Shoptopbar title="Payment" page="Payment" />
            <Payment />
        </React.Fragment>
    )

}

export default PaymentIndex;
